export const SORT_DATA = {
    ASC: 1,
    DESC: -1,
    CLASS_NONE: 'sort',
    CLASS_ASC: 'sort-up',
    CLASS_DESC: 'sort-down',
};